import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset, submit } from "redux-form";
import { BaseComponent } from "BaseComponent";
import _ from "lodash";
import { ColorExtractor } from "react-color-extractor";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { updateUnsavedChanges } from "DashboardMenuAction";
import {
  updateThemeColors,
  updateEventIconLocally,
  updateEventCoverLocally,
} from "BrandingAction";
import { IMAGE_PATH, BASE_IMAGES_URL } from "Constants";
import ImageCropper from "ImageCropper";
import LocaleStrings from "Languages";

class BrandingImages extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      imageEventIcon: "",
      imageEventCover: "",
      eventIconAvailableOnDrop: false,
      eventCoverAvailableOnDrop: false,
      eventIconReset: false,
      eventCoverReset: false,
    };

    this.onDropCover = this.onDropCover.bind(this);
    this.onDrop = this.onDrop.bind(this);

    this.colorsCallback = this.colorsCallback.bind(this);

    this.iconCropperRef = React.createRef();
    this.coverCropperRef = React.createRef();
  }

  eventIconAvailableOnDrop = (available) => {
    if (available !== undefined)
      this.setState({ eventIconAvailableOnDrop: available });
  };

  saveIconImage = (callback) => {
    //We need to call the callback only if image wasn't saved manually just dropped.
    if (this.state.eventIconAvailableOnDrop) {
      this.iconCropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  eventCoverAvailableOnDrop = (available) => {
    if (available !== undefined)
      this.setState({ eventCoverAvailableOnDrop: available });
  };

  saveCoverImage = (callback) => {
    //We need to call the callback only if image wasn't saved manually just dropped.
    if (this.state.eventCoverAvailableOnDrop) {
      this.coverCropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onDrop(files) {
    // debugger;
    this.props.updateUnsavedChanges(true);

    this.setState({ imageEventIcon: files, eventIconReset: true });
    this.props.change("eventicon", files);
    this.props.updateEventIconLocally(files);
  }

  onDropCover(files) {
    this.props.updateUnsavedChanges(true);

    this.setState({ imageEventCover: files, eventCoverReset: true });

    this.props.change("eventcover", files);
    this.props.updateEventCoverLocally(files);
  }

  colorsCallback(colors) {
    // debugger;
    if (colors && colors.length > 0) {
      var colorsData = [];
      colors.map((color, id) => {
        colorsData.push({ color: color, custom: false, selected: false });
      });

      var custom = _.find(this.props.colors, ["custom", true]);

      colorsData.push(custom);

      var colorSelected = _.find(this.props.colors, ["selected", true]);

      if (colorSelected && !colorSelected.custom) {
        colorsData = [colorSelected, ...colorsData];
      }

      this.props.updateThemeColors(colorsData);
    }
  }

  submitBrandingData() {
    //debugger;

    this.saveIconImage(() => {
      this.saveCoverImage(() => {
        this.props.dispatch(submit("Branding-Form"));
      });
    });
    //this.props.dispatch(submit('Branding-Form'));
    //this.props.handleSubmit();
  }

  render() {
    var { handleSubmit, submit, brandingData } = this.props;
    var {
      eventIconAvailableOnDrop,
      eventCoverAvailableOnDrop,
      eventCoverReset,
      eventIconReset,
    } = this.state;

    var eventIconStyle = "appicon-warp";
    var eventCoverStyle = "appicon-warp";

    var { eventicon, eventcover } = brandingData;
    var eventIconPreviewUrl = "";
    var eventCoverPreviewUrl = "";

    if (eventicon && !eventIconReset) {
      eventIconPreviewUrl = `${BASE_IMAGES_URL}/${eventicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      eventIconAvailableOnDrop = true;
    }

    if (eventcover && !eventCoverReset) {
      eventCoverPreviewUrl = `${BASE_IMAGES_URL}/${eventcover}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      eventCoverAvailableOnDrop = true;
    }

    return (
      <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
        <div className="BrandingForm">
          <div className="form-group">
            <div className="vertical-align-center gap-3">
              <label className="control-label-top">
                {LocaleStrings.branding_event_icon}
              </label>
              <OverlayTrigger
                key={`event-logo`}
                placement="right"
                overlay={
                  <Tooltip id={`event-logo`}>
                    <div className="custom-text1-white-normal">
                      {LocaleStrings.branding_event_icon_info}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src={`${IMAGE_PATH}header-icons/infoicon.png`}
                  className="pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            </div>

            <div className="imgPreview">
              <section>
                <ImageCropper
                  displaySize={{
                    width: 128,
                    height: 128,
                  }} // For image display style
                  requiredSize={{
                    width: 256,
                    height: 256,
                  }} // For image size required validation
                  cropperSize={{
                    width: 108,
                    height: 108,
                  }} // Cropper display size.
                  border={10}
                  onImageSave={this.onDrop.bind(this)}
                  onImageChange={this.eventIconAvailableOnDrop}
                  imagepath={eventIconPreviewUrl}
                  imageType="jpg"
                  className="drop-zone-area-custom-image"
                  insideImage={`${IMAGE_PATH}dummy-image-fill@3x.png`}
                  insideImageStyle={{
                    width: 36,
                    height: 36,
                  }}
                  insideText={LocaleStrings.upload_image_text}
                  ref={this.iconCropperRef}
                />

                <Field name="eventicon" component="input" type="hidden" />
              </section>
              {eventIconAvailableOnDrop ? (
                <div style={{ height: 20 }}>
                  {this.state.imageEventIcon ? (
                    <ColorExtractor
                      src={this.state.imageEventIcon}
                      getColors={this.colorsCallback}
                    />
                  ) : null}
                </div>
              ) : (
                <div className={eventIconStyle}>
                  <p className="text-select">
                    {" "}
                    - {LocaleStrings.branding_upload_icon_notes1}{" "}
                  </p>
                  <p className="text-select2">
                    {" "}
                    - {LocaleStrings.branding_upload_icon_notes2}{" "}
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="vertical-align-center gap-3">
              <label className="control-label-top">
                {LocaleStrings.branding_event_cover}
              </label>
              <OverlayTrigger
                key={`event-cover`}
                placement="right"
                overlay={
                  <Tooltip id={`event-cover`}>
                    <div className="custom-text1-white-normal">
                      {LocaleStrings.branding_event_cover_info}
                    </div>
                  </Tooltip>
                }
              >
                <img
                  src={`${IMAGE_PATH}header-icons/infoicon.png`}
                  className="pointer"
                  alt="info icon"
                />
              </OverlayTrigger>
            </div>

            <div className="imgPreview">
              <section>
                <ImageCropper
                  displaySize={{
                    width: 380,
                    height: 214,
                  }} // For image display style
                  requiredSize={{
                    width: 1920,
                    height: 1080,
                  }} // For image size required validation
                  cropperSize={{
                    width: 370,
                    height: 208,
                  }} // Cropper display size.
                  border={10}
                  onImageSave={this.onDropCover.bind(this)}
                  onImageChange={this.eventCoverAvailableOnDrop}
                  imagepath={eventCoverPreviewUrl}
                  imageType="jpg"
                  className="drop-zone-area-custom-image"
                  insideImage={`${IMAGE_PATH}dummy-image-fill@3x.png`}
                  insideImageStyle={{
                    width: 36,
                    height: 36,
                  }}
                  insideText={LocaleStrings.upload_image_text}
                  ref={this.coverCropperRef}
                />
                <Field name="eventcover" component="input" type="hidden" />
              </section>
              {eventCoverAvailableOnDrop ? (
                <div style={{ height: 20 }}>&nbsp;</div>
              ) : (
                <div className={eventCoverStyle}>
                  <p className="text-select">
                    {" "}
                    - {LocaleStrings.branding_upload_icon_notes3}{" "}
                  </p>
                  <p className="text-select2">
                    {" "}
                    - {LocaleStrings.branding_upload_icon_notes4}{" "}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  // var activeColor={};
  // if(state.brandingColor){
  //   activeColor=state.brandingColor.color;
  // }
  return {
    session: state.session,
    brandingData: state.brandingData,
    colors: state.themeColors,
    activeColor:
      Object.keys(state.brandingColor).length == 1
        ? state.brandingColor.color
        : state.brandingColor,
  };
}

function onFormSubmit(values, dispatch, props) {
  values = {
    ...values,
    source: "appbranding",
    themecolor: props.activeColor.color,
  };
  props.submitBrandingDataHandler(values);
}

export default connect(
  mapStateToProps,
  {
    updateUnsavedChanges,
    updateThemeColors,
    updateEventCoverLocally,
    updateEventIconLocally,
  },
  null,
  { forwardRef: true }
)(
  reduxForm({
    form: "Branding-Form",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(BrandingImages)
);
